import { useEffect } from "react";

const CLARITY_PROJECT_ID = "wc1vx1648e";
const COOKIE_PREFERENCES_KEY = "cookie_preferences";

interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

export const useClarity = () => {
  useEffect(() => {
    if (!CLARITY_PROJECT_ID) return;

    const checkAndLoadClarity = () => {
      const savedPrefs = localStorage.getItem(COOKIE_PREFERENCES_KEY);
      if (!savedPrefs) return;

      try {
        const preferences: CookiePreferences = JSON.parse(savedPrefs);
        if (preferences.analytics) {
          loadClarity();
        }
      } catch {
        // Invalid preferences
      }
    };

    const loadClarity = () => {
      if (document.getElementById("clarity-script")) return;

      const script = document.createElement("script");
      script.id = "clarity-script";
      script.type = "text/javascript";
      script.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");
      `;
      document.head.appendChild(script);
    };

    checkAndLoadClarity();

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === COOKIE_PREFERENCES_KEY) checkAndLoadClarity();
    };
    window.addEventListener("storage", handleStorageChange);

    const handlePreferencesUpdate = () => checkAndLoadClarity();
    window.addEventListener("cookie-preferences-updated", handlePreferencesUpdate);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("cookie-preferences-updated", handlePreferencesUpdate);
    };
  }, []);
};
